import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SalesPayment, SalesPaymentCreate, SalesPaymentFilter } from '../data/salesPayment';

export function createSalesPaymentService(client: AxiosInstance) {
  return createCrudService<SalesPayment, SalesPaymentCreate, SalesPaymentFilter>(
    client,
    '/sales/SalesPayment',
    'id',
  );
}

export type SalesPaymentService = CrudService<SalesPayment, SalesPaymentCreate, SalesPaymentFilter>;
